export const bookingTimeslotsApi = 'https://readdy.ai/api/public/calendar/timeslots/7122a5c6-55e6-4369-b3a5-ec5932c2597b.b333cc76f9b1099174163058965c857e67a3b8efa883e1e5176e995d026b55ae';

export const bookingAppointmentsApi = 'https://readdy.ai/api/public/calendar/appointments/7122a5c6-55e6-4369-b3a5-ec5932c2597b.b333cc76f9b1099174163058965c857e67a3b8efa883e1e5176e995d026b55ae';

export const bookingTexts = {
  stepDate: '1 · Pick a day',
  stepTime: '2 · Pick a time',
  stepDetails: '3 · Your details',
  prevMonth: 'Previous month',
  nextMonth: 'Next month',
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  loading: 'Firing up the calendar…',
  loadError: 'We could not load open tables right now.',
  retry: 'Try again',
  noSlots: 'No open tables right now — check back soon.',
  slotsFor: 'Open times on',
  back: 'Back',
  reviewTitle: 'Your table',
  reviewDate: 'Date',
  reviewTime: 'Time',
  modifyTime: 'Modify time',
  nameLabel: 'Your name *',
  namePlaceholder: 'Alex Rivera',
  phoneLabel: 'Phone *',
  phonePlaceholder: '(415) 555-0142',
  partyLabel: 'Party size',
  locationLabel: 'Location',
  notesLabel: 'Anything we should know?',
  notesPlaceholder: 'Birthday, high chair, allergies…',
  submit: 'Book my table',
  submitting: 'Booking…',
  required: 'Please add your name and phone number.',
  submitError: 'Booking failed. Please try again.',
  successTitle: 'You are booked!',
  successBody: 'See you at the grill. We will call if anything changes.',
  bookAnother: 'Book another table',
};